import styled from '@emotion/styled';
import NextLink from 'next/link';
import { FC, Fragment } from 'react';
import useSWR from 'swr';

import { SpeakerCard, SpeakerCardSkeleton } from '@/components/ui/shared/profile/SpeakerCard/SpeakerCard';
import { useStores } from '@/hooks/useStores';
import { MenuGroup } from '@/resources/MenuGroup';
import { MenuGroupMember } from '@/resources/MenuGroupMember';
import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

import { fetchGroupMembers, FETCH_GROUP_MEMBERS_KEY } from '../../fetchers/group-members';

const Wrapper = styled.div<IThemeProps>`
  margin: 32px 0 72px;
  display: grid;
  grid-template-columns: repeat(auto-fit, 155px);
  grid-gap: 56px;
  column-gap: 24px;

  img {
    height: 155px;
  }

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    grid-template-columns: repeat(auto-fit, 185px);
    column-gap: 32px;

    img {
      height: 185px;
    }
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    grid-template-columns: repeat(auto-fit, 205px);
    column-gap: 40px;

    img {
      height: 205px;
    }
  }
`;

interface IGroupPreviewProps {
  menuGroupItem: MenuGroup;
  loadItemsOnRender?: boolean;
}

export const GroupPreview: FC<IGroupPreviewProps> = ({ menuGroupItem }) => {
  const { store } = useStores();

  const groupMembersFilters = {
    menu_group_id: menuGroupItem.id,
  };

  const { data: membersResponse } = useSWR([FETCH_GROUP_MEMBERS_KEY, menuGroupItem.id], () =>
    fetchGroupMembers(store, groupMembersFilters, { include: ['profile'], page: { size: 500 } })
  );

  const members = membersResponse?.data as Array<MenuGroupMember>;

  return (
    <Wrapper>
      {members ? (
        <Fragment>
          {members.map((member) => (
            <SpeakerCard key={member.id} showImage={menuGroupItem.type === 'speakers'} profile={member.profile} />
          ))}
        </Fragment>
      ) : (
        <Fragment>
          {Array.from({ length: 5 }, (_, i) => (
            <SpeakerCardSkeleton key={i} flexBasis={['158px', null, '208px', null, '214px']} />
          ))}
        </Fragment>
      )}
    </Wrapper>
  );
};
